export { default as MUNICIPAL_BOUNDARY } from "./municipal-boundary.json";
export const MELBOURNE_LATITUDE = -37.8136;
export const MELBOURNE_LONGITUDE = 144.9631;
export const MELBOURNE_VIEWPORT = {
    latitude: MELBOURNE_LATITUDE,
    longitude: MELBOURNE_LONGITUDE,
    zoom: 14,
};
export const MELBOURNE_BOUNDS = [
    [144.9, -37.85],
    [144.99, -37.776],
];
